export enum Permission {
  // Tenant
  DeleteTenant = 'deleteTenant',
  GetTenant = 'getTenant',
  GetTenants = 'getTenants',

  // Admin Settings
  GetTenantAdminSettings = 'getTenantAdminSettings',
  UpdateAdminPassword = 'updateAdminPassword',
  UpdateAdminSettings = 'updateAdminSettings',

  // Domains
  GetDomains = 'getDomains',
  CreateDomain = 'createDomain',
  CheckDomain = 'checkDomain',
  DeleteDomain = 'deleteDomain',

  // Audit Events
  GetAuditEvents = 'getAuditEvents',

  // IDPs
  CreateIdp = 'createIdp',
  GetIdp = 'getIdp',
  DeleteIdp = 'deleteIdp',
  UpdateIdp = 'updateIdp',

  // Instance
  GetInstances = 'getInstances',
  CreateInstance = 'createInstance',
  DeleteInstance = 'deleteInstance',
  UpdateInstance = 'updateInstance',

  // Artifacts
  AccessArtifacts = 'accessArtifacts',
}
